// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
body {
    background-color: #f1f1f1;
    /* overflow: auto; */
    /* allows scrolling */
    font-family: "Inter", sans-serif;
    margin: 0;
    padding: 0;
}

.userDataInput {
    width: 100%;
    /* padding: 4vh 2vw; */
    /* overflow-y: auto; */
}

.MainInput {
    background-color: white;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    padding: 4vh 4vw 8vh 4vw;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.topText {
    padding-top: 2vh !important;
}

.dataTitle {
    text-align: left;
    font-size: 1.8em;
    padding: 1%;
    font-family: Inter, sans-serif;
    line-height: 1.4em;
    margin-bottom: 1vh;
}

.dataSubtitle {
    text-align: left;
    font-size: 1.2em;
    padding: 1%;
    font-family: Inter, sans-serif;
    line-height: 1.3em;
    margin-bottom: 3vh;
}

.dataInputLabel {
    color: #0f172a;
    text-align: left;
    margin: 0 0 6px 32px;
    font-size: 15px;
    font-weight: 500;
    line-height: 1.4em;
}

.dataInputBlock {
    position: relative;
    display: flex;
    align-items: center;
    width: 60%;
    min-height: 56px;
    margin-left: 32px;
    margin-bottom: 20px;
    border-radius: 6px;
    border: 1px solid #cbd5e1;
    background: #f8fafc;
    padding: 2px;
    box-sizing: border-box;
}

.dataInputBlock>input,
.dataInputBlock>select,
.dataInputBlock>textarea {
    width: 100%;
    height: 48px;
    padding: 10px 16px;
    color: #334155;
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.3px;
    border: none;
    outline: none;
    background-color: #fff;
    border-radius: 6px;
    box-sizing: border-box;
}

.dataInputBlock>textarea {
    height: auto;
    resize: vertical;
    min-height: 100px;
}

.MainInput>hr {
    width: 80%;
    margin: 5vh auto 4vh auto;
    border: none;
    border-top: 1px solid #e2e8f0;
}

.finishButton {
    /* width: 30%; */
    height: 54px;
    margin-left: 32px;
    border-radius: 6px;
    border: 0.5px solid #3ccb94;
    background: #2e8b57;
    color: #fff;
    font-family: Inter, sans-serif;
    font-weight: 500;
    font-size: 1.1em;
    letter-spacing: 0.2px;
    text-align: center;
    cursor: pointer;
    transition: background 0.25s ease;
}

.finishButton:hover {
    background: #276f47;
}

.finishButton:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.ErrorBox {
    width: 60%;
    margin-left: 32px;
    color: red;
    text-align: left;
    font-size: 15px;
    line-height: 1.5em;
    min-height: 2em;
}

.dataInputBlock.error {
  border: 1px solid #dc2626 !important; /* red border */
  background-color: #fef2f2; /* light red background */
}

.fieldError {
  color: #dc2626;
  font-size: 13px;
  margin: 4px 0 12px 34px;
  font-family: Inter, sans-serif;
}

/* Mobile View */
@media (max-width: 768px) {
    .dataInputBlock {
        width: 85%;
        margin-left: 20px;
    }

    .dataTitle {
        font-size: 1.3em;
    }

    .dataSubtitle {
        font-size: 1em;
    }

    .finishButton {
        width: 70%;
    }
}

@media (max-width: 480px) {
    .dataTitle {
        font-size: 1em;
    }

    .dataSubtitle {
        font-size: 0.8em;
    }

    .dataInputBlock {
        width: 90%;
        margin-left: 5%;
    }

    .dataInputBlock>input,
    .dataInputBlock>select {
        font-size: 14px;
    }

    .finishButton {
        width: 80%;
        font-size: 1em;
    }
}`, "",{"version":3,"sources":["webpack://./src/screens/Assessment/UserData/UserData.css"],"names":[],"mappings":";AACA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,qBAAqB;IACrB,gCAAgC;IAChC,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,wBAAwB;IACxB,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;;;IAGI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;EACE,oCAAoC,EAAE,eAAe;EACrD,yBAAyB,EAAE,yBAAyB;AACtD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;IACI;QACI,UAAU;QACV,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,cAAc;IAClB;AACJ","sourcesContent":["\nbody {\n    background-color: #f1f1f1;\n    /* overflow: auto; */\n    /* allows scrolling */\n    font-family: \"Inter\", sans-serif;\n    margin: 0;\n    padding: 0;\n}\n\n.userDataInput {\n    width: 100%;\n    /* padding: 4vh 2vw; */\n    /* overflow-y: auto; */\n}\n\n.MainInput {\n    background-color: white;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    padding: 4vh 4vw 8vh 4vw;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n.topText {\n    padding-top: 2vh !important;\n}\n\n.dataTitle {\n    text-align: left;\n    font-size: 1.8em;\n    padding: 1%;\n    font-family: Inter, sans-serif;\n    line-height: 1.4em;\n    margin-bottom: 1vh;\n}\n\n.dataSubtitle {\n    text-align: left;\n    font-size: 1.2em;\n    padding: 1%;\n    font-family: Inter, sans-serif;\n    line-height: 1.3em;\n    margin-bottom: 3vh;\n}\n\n.dataInputLabel {\n    color: #0f172a;\n    text-align: left;\n    margin: 0 0 6px 32px;\n    font-size: 15px;\n    font-weight: 500;\n    line-height: 1.4em;\n}\n\n.dataInputBlock {\n    position: relative;\n    display: flex;\n    align-items: center;\n    width: 60%;\n    min-height: 56px;\n    margin-left: 32px;\n    margin-bottom: 20px;\n    border-radius: 6px;\n    border: 1px solid #cbd5e1;\n    background: #f8fafc;\n    padding: 2px;\n    box-sizing: border-box;\n}\n\n.dataInputBlock>input,\n.dataInputBlock>select,\n.dataInputBlock>textarea {\n    width: 100%;\n    height: 48px;\n    padding: 10px 16px;\n    color: #334155;\n    font-family: Inter, sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    letter-spacing: 0.3px;\n    border: none;\n    outline: none;\n    background-color: #fff;\n    border-radius: 6px;\n    box-sizing: border-box;\n}\n\n.dataInputBlock>textarea {\n    height: auto;\n    resize: vertical;\n    min-height: 100px;\n}\n\n.MainInput>hr {\n    width: 80%;\n    margin: 5vh auto 4vh auto;\n    border: none;\n    border-top: 1px solid #e2e8f0;\n}\n\n.finishButton {\n    /* width: 30%; */\n    height: 54px;\n    margin-left: 32px;\n    border-radius: 6px;\n    border: 0.5px solid #3ccb94;\n    background: #2e8b57;\n    color: #fff;\n    font-family: Inter, sans-serif;\n    font-weight: 500;\n    font-size: 1.1em;\n    letter-spacing: 0.2px;\n    text-align: center;\n    cursor: pointer;\n    transition: background 0.25s ease;\n}\n\n.finishButton:hover {\n    background: #276f47;\n}\n\n.finishButton:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.ErrorBox {\n    width: 60%;\n    margin-left: 32px;\n    color: red;\n    text-align: left;\n    font-size: 15px;\n    line-height: 1.5em;\n    min-height: 2em;\n}\n\n.dataInputBlock.error {\n  border: 1px solid #dc2626 !important; /* red border */\n  background-color: #fef2f2; /* light red background */\n}\n\n.fieldError {\n  color: #dc2626;\n  font-size: 13px;\n  margin: 4px 0 12px 34px;\n  font-family: Inter, sans-serif;\n}\n\n/* Mobile View */\n@media (max-width: 768px) {\n    .dataInputBlock {\n        width: 85%;\n        margin-left: 20px;\n    }\n\n    .dataTitle {\n        font-size: 1.3em;\n    }\n\n    .dataSubtitle {\n        font-size: 1em;\n    }\n\n    .finishButton {\n        width: 70%;\n    }\n}\n\n@media (max-width: 480px) {\n    .dataTitle {\n        font-size: 1em;\n    }\n\n    .dataSubtitle {\n        font-size: 0.8em;\n    }\n\n    .dataInputBlock {\n        width: 90%;\n        margin-left: 5%;\n    }\n\n    .dataInputBlock>input,\n    .dataInputBlock>select {\n        font-size: 14px;\n    }\n\n    .finishButton {\n        width: 80%;\n        font-size: 1em;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
